/* @flow */
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { inject } from 'mobx-react';
import { observable } from 'mobx';
import { translate } from 'react-i18next';
import { RequireForAccess, ReactAccessProvider } from 'react-access';

import Tooltip from '@material-ui/core/Tooltip';
import AuthenticationStore from 'stores/AuthenticationStore';
import UserStore from 'stores/UserStore';
import AppReleaseInfo from 'components/AppReleaseInfo/AppReleaseInfo';
import { observerWithRouter } from 'utils/mobx';
import FeatureFlag from 'utils/FeatureFlag';

import leftMenuLinks from './leftMenuLinks';

import styles from './LeftMenu.module.scss';

type TypeProps = {
  authenticationStore: AuthenticationStore,
  userStore: UserStore,
};

@translate()
@inject('authenticationStore', 'userStore')
@observerWithRouter
export default class LeftMenu extends React.Component<*> {
  navContainerRef = React.createRef();

  @observable isHovered = true;

  enterTime = 0;

  leaveTime = 0;

  slideDelay = 250;

  handleMouseEnter = () => {
    this.leaveTime = 0;
    this.enterTime = new Date().getTime();

    setTimeout(
      function() {
        //Start the timer
        if ((this.leaveTime - this.enterTime) * -1 < this.slideDelay && this.isHovered) {
          // if (this.slideDelay && this.state.isHovered) {
          // stay closed
        } else {
          this.isHovered = true;
        }
      }.bind(this),
      this.slideDelay
    );
  };

  handleMouseLeave = e => {
    this.leaveTime = new Date().getTime();
    this.isHovered = false;
  };

  toggleNavigation = e => {
    this.isHovered ? this.handleMouseLeave(e) : this.handleMouseEnter(e);
  };

  render() {
    const { authenticationStore, userStore, t } = this.props;
    const isLoggedInClass: string =
      authenticationStore.authenticationState === 'authed' ? styles['logged-in'] : '';
    const isHoveredClass: string = this.isHovered ? styles['is-hovered'] : '';

    return (
      <nav
        ref={this.navContainerRef}
        className={`${styles['left-menu']} ${isLoggedInClass} ${isHoveredClass}`}
      >
        <ReactAccessProvider permissions={[userStore.userRoleId]}>
          <ul className={styles['main-navigation']}>
            {leftMenuLinks.map(link => {
              if (link.to === '/reporting') {
                return (
                  <FeatureFlag name="reporting" key={`left-menu-link-${link.label}`}>
                    <LeftMenuLink link={link} />
                  </FeatureFlag>
                );
              }

              return <LeftMenuLink key={`left-menu-link-${link.label}`} link={link} />;
            })}
          </ul>
        </ReactAccessProvider>
        <AppReleaseInfo isHovered={this.isHovered} toggleNavigation={this.toggleNavigation} />
      </nav>
    );
  }
}

type LeftMenuLinkProps = {
  link: any,
};
@translate()
class LeftMenuLink extends React.Component<LeftMenuLinkProps> {
  render() {
    const { link, t } = this.props;
    const spanClassName = `${styles['text-label']} ${styles['ellipsis-text']}`;
    const isLabelLengthMax18 = t(link.label).length > 18;

    return (
      <RequireForAccess key={link.label} permissions={link.permissions}>
        <li>
          {link.absolute ? (
            <div className={`${styles[link.className]}`}>
              <a href={link.to} target={'_blank'}>
                <svg className={styles.rotate180}>
                  <use xlinkHref={link.icon} />
                </svg>
                <span className={styles['text-label']}>{t(link.label)}</span>
              </a>
            </div>
          ) : (
            <NavLink
              to={link.to}
              className={styles['ellipsis-container']}
              activeClassName={styles.active}
              isActive={(match, location) => {
                if (!match) {
                  return link.alias === location.pathname || false;
                }

                return match.path === location.pathname;
              }}
            >
              <svg>
                <use xlinkHref={link.icon} />
              </svg>
              {isLabelLengthMax18 ? (
                <Tooltip title={t(link.label)}>
                  <span className={spanClassName}>{t(link.label)}</span>
                </Tooltip>
              ) : (
                <span className={spanClassName}>{t(link.label)}</span>
              )}
            </NavLink>
          )}
        </li>
      </RequireForAccess>
    );
  }
}
